<template>
<div class="el-main">
  <!-- <div class="card"
    v-show="currentCardId == 'occupation'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職種</h2>
        <p>後の入力項目で選択した職種に合わせた例文が使えます</p>
      </div>
      <div class="card-content">
        <div>
        <el-select v-model="formatData.occupation"
          placeholder="Select">
          <el-option v-for="item in occupationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        </div>
      </div>
    </div>
  </div> -->

  <div class="card"
    v-show="currentCardId == 'job-summary'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務要約</h2>
        <p>自分の職務経歴を100～150文字程度でわかりやすくまとめましょう</p>
      <div class="add-item">
        <el-button @click="$modal.show('summary-dialog')"
            style="background-color:#004D40;border-color:#004D40;"
                   type="success">例文から追加</el-button>
      </div>
      </div>
      <div class="card-content">
        <modal name="summary-dialog"
               :adaptive="true"
               :scrollable="true"
               height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('summary-dialog');"
                       icon="el-icon-close"
                       type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in filtered(exampleSentences.summary)"
                v-on:click="formatData.jobSummary=item.sentences.replace(/<br>/ig, '\n');$modal.hide('summary-dialog')"
                :key="index">
              <div class="title">{{ item.name }}</div>
              <div class="body"
                   v-html="item.sentences"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('summary-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
                  v-model="formatData.jobSummary"
                  :autosize="{minRows: 5, maxRows: 15}"></el-input>
      </div>
    </div>
  </div>

  <div class="card"
    v-show="currentCardId == 'skills-to-use'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>活かせるスキル・経験</h2>
        <p>応募先にアピールできるスキル（技能）や資格、経験などを入力しましょう</p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="add-item">
          </div>
          <transition-group name="fade"
                            tag="div">
            <history-item-skill v-on:add-history-item="addSkillHistory"
                          v-on:delete-history-item="deleteSkillHistory"
                          v-on:move-history-item="moveSkillHistory"
                          v-for="(item, index) in formatData.skillsToUse"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.skillsToUse.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :ref="'SkillHistory_' + index"
                          :minYear="basicData.birthYear"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="' スキルや資格の名称を入力'"
                          :descriptionPlaceholder2="' 習熟度や説明を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item-skill>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addSkillHistory()"></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
    v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務経歴</h2>
        <p>今までに在籍した会社の概要を入力しましょう。<br>会社ごとに、業務の実績や参加プロジェクトの説明も追加できます。</p>
        <el-checkbox v-model="formatData.notDisplayOmonajiseki">【主な実績】のラベルを表示しない</el-checkbox>
          <!-- <div v-for="(item, index) in formatData.jobHistories"> -->
            <!-- {{item.uuid}} -->
            <!-- <div v-for="(item2, index2) in item.projects">_{{item2.uuid}}</div> -->
          <!-- </div> -->
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addJobHistory"
                          v-on:delete-history-item="deleteJobHistory"
                          v-on:move-history-item="moveJobHistory"
                          v-on:add-project-history-item="addProjectHistory"
                          v-on:delete-history-item-detail="deleteHistoryDetail"
                          v-on:move-history-item-detail="moveJobHistoryDetail"
                          v-for="(item, index) in formatData.jobHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.jobHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :ref="'JobHistory_' + index"
                          :minYear="basicData.birthYear"
                          :createDate="formatData.createDate"
                          :activeHistoryItem="activeHistoryItem"
                          :descriptionPlaceholder="'会社名を入力'"
                          :descriptionMaxLength="descriptionMaxLength">
            </history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addJobHistory()"></el-button>
            <!--
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addProjectHistory()"></el-button>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
    v-show="currentCardId == 'pr-message'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自己PR</h2>
        <p>応募するポジションに役立つ自身の能力や意欲をアピールしましょう</p>
        <div class="add-item">
          <el-button @click="$modal.show('pr-dialog')"
            style="background-color:#004D40;border-color:#004D40;"
                     type="success">例文から追加</el-button>
        </div>
      </div>
      <div class="card-content">
        <modal name="pr-dialog"
               :adaptive="true"
               :scrollable="true"
               height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('pr-dialog');"
                       icon="el-icon-close"
                       type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in filtered(exampleSentences.prMessage)"
                v-on:click="formatData.prMessage=item.sentences.replace(/<br>/ig, '\n');$modal.hide('pr-dialog')"
                :key="index">
              <div class="title">{{ item.name}}</div>
              <div class="body"
                   v-html="item.sentences"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('pr-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
                  v-model="formatData.prMessage"
                  :autosize="{minRows: 6, maxRows: 15}"></el-input>
      </div>
    </div>
  </div>

  <div class="card"
       v-show="currentCardId == 'create-date'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務経歴書の作成日を入力</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <div class="create-date-action">
            <div class="action-item">
              <el-button class="button-block"
                         :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                         @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
            </div>
            <div class="action-item">
              <el-button class="button-block"
                         :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                         @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
            </div>
            <div class="action-item">
              <el-date-picker v-model="formatData.createDate"
                              type="date"
                              :clearable="false"
                              placeholder="選択してください"
                              :format="'yyyy年M月d日'"
                              ref="create_date">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card"
    v-show="currentCardId == 'output'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>ダウンロード</h2>
        <p>作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
      </div>
      <div class="card-content">
        <div class="text-center fluffy">
          <your-yagi :your-yagi-class="{}"
                     :yagi-options="{dialogEnabled: false, rubyEnabled: false, messageEnabled: true, fixedMessage: 'さいごまでがんばった！'}"></your-yagi>
        </div>
        <div class="button-download-pdf">
          <h3>フォント</h3>
          <p v-if="formatData.selFontStyle" :style="formatData.selFontStyle"><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            style="border-color:#555;color:#000"
            id="preview-button-format-edit"><i class="el-icon-view"></i> {{formatData.selectedFontName}}</el-button></p>
          <p v-else><el-button v-ripple
            plain
            @click="$eventHub.$emit('show-preview');"
            type="success"
            id="preview-button-format-edit"><i class="el-icon-view"></i> デフォルト</el-button></p>
          <div v-if="!$firebase.isAuthenticated">
            <a :href="'/login?frompage=' + this.formatId" ><img src="/static/renew_img/bnr/banner_not_login.png" style="text-align:center;width:100%"></a>
          </div>
          <div v-if="$firebase.isAuthenticated && true"
               class="attention-logged-in">
            <p>PDFをあなたのメール宛てに送ります。</p>
            <el-button id="pdf-mail-edit"
                       type="primary"
                       plain
                       class="button-block"
                       style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                       :disabled="!$deviceLib.isOnline ||!mailPdfEnabled"
                       @click="$eventHub.$emit('mail-PDF');mailPdfEnabled = false">
              <i class="el-icon-message"></i> PDFをメールで送る
            </el-button>
            <p>バックアップデータはマイページで確認できます</p>
            <el-button class="button-block"  v-if="false"
                       :disabled="!$deviceLib.isOnline"
                       @click="$router.push({name: 'backupIndex'})"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

          </div>
          <el-button id="pdf-download-edit"
                     v-if="$firebase.isAuthenticated && !true"
                     class="button-block animation"
                     type="primary"
                     style="background-color:#E95B10;border-color:#E95B10"
                     :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                     @click="$eventHub.$emit('download-PDF');downloadPdfEnabled = false">
            <i class="el-icon-download"></i> ダウンロードする
          </el-button>
          <div v-if="$firebase.isAuthenticated" class="attention-logged-in">
            <el-button id="pdf-eprint-edit"
                       type="success"
                       class="button-block"
                       style="background-color:#004D40;border-color:#004D40"
                       @click="$eventHub.$emit('show-preview-4conv')">
              <i class="el-icon-printer"></i> コンビニで印刷する
            </el-button>
            <p>※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。</p>
          </div>
          <br/>
          <div >
            <a href="https://bit.ly/3n8rCnv" target="_blank"><img src="/static/renew_img/bnr/download_banner_20220622.png" style="text-align:center;width:100%"></a>
          </div>
          <div v-if="isMynabi"
               class="attention-logged-in">
            <el-button id="mynavi-back"
                       type="primary"
                       plain
                       class="button-block"
                       :disabled="!$deviceLib.isOnline"
                       onclick="location.href='https://tenshoku.mynavi.jp/knowhow/rirekisho?af=yagish'">
              【履歴書の書き方を見る】
            </el-button>
            <p class="addition">採用担当者のチェックポイント・送り方なども解説！</p>
          </div>
          <br/>
          <el-button id="pdf-download-edit"
                     v-if="$firebase.isAuthenticated && true"
                     class="button-block animation"
                     type="primary"
                     :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                     style="background-color:#fce8ef;border-color:#f4a2be;color:#e3165c"
                     @click="$eventHub.$emit('download-PDF');downloadPdfEnabled = false">
            <i class="el-icon-download"></i> ダウンロードする
          </el-button>
          <br>
          <div v-if="$firebase.isAuthenticated && !true"
               class="attention-logged-in">
            <p>PDFをあなたのメール宛てに送ります。</p>
            <el-button id="pdf-mail-edit"
                       type="primary"
                       plain
                       class="button-block"
                       style="color: #E95B10;background-color: #FFF3EC;border-color: #FF813F;"
                       :disabled="!$deviceLib.isOnline ||!mailPdfEnabled"
                       @click="$eventHub.$emit('mail-PDF');mailPdfEnabled = false">
              <i class="el-icon-message"></i> PDFをメールで送る
            </el-button>
            <p>入力したデータの引き継ぎにはバックアップをおすすめします</p>
            <el-button class="button-block"  v-if="false"
                       :disabled="!$deviceLib.isOnline"
                       @click="$router.push({name: 'backupIndex'})"><i class="el-icon-upload"></i> バックアップ画面を開く</el-button>

          </div>
          <div v-if="!$firebase.isAuthenticated"
               class="attention-not-logged-in">
            <p>ログインすると、他の端末からも続きを書けるようにデータをバックアップできます。<br/>また、「コンビニ印刷」のサービスをご利用いただけます。</p>
            <login-forms :is-plain-button="true" />
          </div>

          <div class="error"
               v-if="!$deviceLib.isOnline">現在オフラインのためダウンロードはご利用頂けません。ネットワークに繋げてからお試しください。
          </div>
        </div>
      </div>
      <div class="card-content">
        <el-collapse v-model="downloadActiveCollapses">
          <el-collapse-item title="ヤギにはがきを渡す"  v-if="false"
                            name="postcard">
            <div><router-link id="footer-link-postcard"
                         :to="{name: 'postCard'}"><img src="/static/img/postcard/postyagi.svg" alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
          </el-collapse-item>
          <el-collapse-item title="他の端末から続きを書くには"
                            name="backup">
            <div>他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>

</div>
</template>
<style lang="scss" scoped>
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}
</style>
<script>
// import HistoryItem from './RirekishoParts/HistoryItem'
import HistoryItemSkill from './ShokurekishoParts/HistoryItemSkill'
import HistoryItemJob from './ShokurekishoParts/HistoryItemJob'
// import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
// import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const SkillHistoryData = function (columns) {
  this.skillname = columns.skillname || ''
  this.years = Number(columns.years) || ''
  this.description = columns.description || ''
  this.uuid = uuidv4()
}
// const SkillHistoryData2 = class sh {
//   constructor (columns) {
//     this.skillname = columns.skillname || ''
//     this.years = Number(columns.years) || ''
//     this.description = columns.description || ''
//     this.uuid = uuidv4()
//   }
//   run () {
//     return (this.uuid)
//   }
// }
const JobHistoryData = function (columns) {
  this.companyName = columns.companyName || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.isContinuing = columns.isContinuing || false
  this.capitalStock = columns.capitalStock || ''
  this.numberOfEmployees = columns.numberOfEmployees || ''
  this.businessArea = columns.businessArea || ''
  this.projects = columns.projects || []
  this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
  this.projectTitle = columns.projectTitle || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.contentsOfProject = columns.contentsOfProject || ''
  this.envAndScale = columns.envAndScale || ''
  this.position = columns.position || ''
  this.uuid = uuidv4()
}

export default {
  name: 'ShokurekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItemJob,
    'history-item-skill': HistoryItemSkill,
    // 'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'shokumukeirekisho',
      formatData: {
        createDate: null,
        occupation: 'others',
        jobSummary: '',
        experienceAndKnowledge: '',
        skillsToUse: [],
        jobHistories: [],
        licenseHistories: [],
        prMessage: ''
      },
      activeHistoryItem: '',
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      eprintPdfEnabled: true,
      downloadActiveCollapses: ['postcard'],
      occupationOptions: [
        {
          value: 'engineer',
          label: 'エンジニア'
        },
        {
          value: 'sales',
          label: '営業'
        },
        {
          value: 'backoffice',
          label: '事務'
        },
        {
          value: 'others',
          label: 'その他'
        }
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    }
  },
  watch: {
    formatData: function () {
      // console.log(this.formatData.jobHistories.length)
      if (this.formatData.jobHistories.length === 0) {
        // this.addJobHistory()
        // this.addProjectHistory(0)
        // this.createProjectHistoryItem()
        // console.log('asdf')
      }
    }
  },
  methods: {
    filtered: function (obj) {
      var selectedOccupation = this.formatData.occupation
      return obj.filter(function (item) {
        return item.type === selectedOccupation
      })
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createJobHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new JobHistoryData(columns)
    },
    createProjectHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new ProjectHistoryData(columns)
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addSkillHistory: function (index, columns) {
      const historyList = this.formatData.skillsToUse
      if (!columns) columns = {}
      const newHistoryItem = new SkillHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addJobHistory: function (index, columns) {
      const historyList = this.formatData.jobHistories
      if (!columns) columns = {}
      const newHistoryItem = new JobHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addProjectHistory: function (index, columns) {
      // const targetItem = this.formatData.jobHistories.find((item) => {
      //   return (item.uuid === this.activeHistoryItem)
      // })
      const targetItem = this.formatData.jobHistories[index]
      if (!columns) columns = {}
      const newHistoryItem = new ProjectHistoryData(columns)
      targetItem.projects.push(newHistoryItem)
    },
    moveSkillHistory: function (params) {
      this.moveHistory(this.formatData.skillsToUse, params)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    moveJobHistoryDetail: function (params, parentIndex) {
      this.moveHistory(this.formatData.jobHistories[parentIndex].projects, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteSkillHistory: function (index) {
      this.formatData.skillsToUse.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteHistoryDetail: function (index, index2) {
      console.log(index, index2)
      this.formatData.jobHistories[index].projects.splice(index2, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
<style scoped lang="scss">
</style>
